export default __webpack_public_path__ + "static/media/floorSliderFirst.e904ae3a.jpeg";